import {PayloadAction} from "@reduxjs/toolkit";
import {Reducer} from "redux";
import {INIT} from "../rootActions";

export type ThemeConfigState = {
  isMultiViewer: boolean;
  showDatasetListInCategoriesTree: boolean;
  showLangsAsText: boolean;
  defaultFreq: string | null;
  nodesGridProps: {[key: string]: number};
  CatalogPortionPreviewProps: {[key: string]: number};
  initAsFlatTable: boolean | null; // missing in MV themes
  preserveFiltersWithDynamic: boolean | null; // missing in MV themes
  showStatViewerFooter: boolean | null; // missing in MV themes
  showStatViewerInfoButton: boolean | null; // missing in MV themes
  defaultCriteriaVisibility: boolean | null; // missing in MV themes
  configsToMerge: string[];
  appConfig: {[key: string]: any};
};

const themeConfigReducer: Reducer<ThemeConfigState, PayloadAction<any>> = (state = null, action) => {
  switch (action.type) {
    case INIT: {
      return action.payload.themeConfig;
    }
    default:
      return state;
  }
};

export default themeConfigReducer;
